import { createRouter, createWebHashHistory } from 'vue-router'
import SignInView from '../views/SignInView.vue'
import { useUserStore } from '@/stores/user';

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            redirect: '/sign-in',
        },
        {
            path: '/sign-in',
            name: 'sign-in',
            component: SignInView
        },
        {
            path: '/sign-out',
            name: 'sign-out',
            component: () => import('../views/SignOutView.vue'),
        },
        {
            path: '/sign-up',
            name: 'sign-up',
            component: () => import('../views/SignUpView.vue')
        },
        {
            path: '/pricing',
            name: 'pricing',
            component: () => import('../views/PricingView.vue')
        },
        {
            path: '/carwash/:service_id',
            name: 'carwash',
            // route level code-splitting
            // this generates a separate chunk (ServicesView.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('@/views/ServicesView.vue'),
            children: [
                {
                    path: 'home',
                    name: 'carwash-home',
                    component: () => import('@/views/carwash/HomeView.vue'),
                },
                {
                    path: 'queue',
                    name: 'carwash-queue',
                    component: () => import('@/views/carwash/QueueView.vue'),
                },
                {
                    path: 'analytics',
                    name: 'carwash-analytics',
                    component: () => import('@/views/carwash/analytics/AnalyticsView.vue'),
                },
                {
                    path: 'reports',
                    name: 'carwash-reports',
                    component: () => import('@/views/carwash/reports/ReportsView.vue'),
                },
                {
                    path: 'employees',
                    name: 'carwash-employees',
                    component: () => import('@/views/carwash/EmployeesView.vue'),
                },
                {
                    path: 'vehicles-pricing',
                    name: 'carwash-vehicle-pricing',
                    component: () => import('@/views/carwash/VehiclePriceList.vue'),
                },
                {
                    path: 'service-offers',
                    name: 'carwash-service-offers',
                    component: () => import('@/views/carwash/ServiceOffersView.vue'),
                },
                {
                    path: 'general-settings',
                    name: 'carwash-general-settings',
                    component: () => import('@/views/carwash/GeneralSettingsView.vue'),
                },
            ]
        },
    ]
});

router.beforeEach((to, from) => {
    const userStore = useUserStore();

    const noAuthPages = ['sign-in', 'sign-up'];

    // require user login except the login, sign-up
    if (
        (!userStore.api_token || !userStore.refresh_token) && 
        !noAuthPages.includes(to.name)    
    ) {
        return { name: 'sign-in' };
    }
});

router.afterEach((to, from) => {
    if (location.hostname === 'console.carheroph.app' && window.goatcounter && window.goatcounter.count) {
        window.goatcounter.count({
            path: location.pathname + location.search + location.hash,
        })
    }
});

export default router
